import {ApolloClient} from 'apollo-client';
import {BatchHttpLink} from 'apollo-link-batch-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {dataIdFromObjectForTripboard} from '@homeaway/react-trip-board-button';
import {defaultDataIdFromObject} from 'apollo-cache-inmemory';
import {API} from './routes';

const cache = new InMemoryCache({
    dataIdFromObject: (object) => dataIdFromObjectForTripboard(object) || defaultDataIdFromObject(object)
}).restore(window.__INITIAL_APOLLO_STATE__);

// setup link with crumb support
const link = new BatchHttpLink({
    uri: `${API}/graphql`,
    credentials: 'same-origin',
    headers: {
        'x-csrf-token': window.ha.crumb,
        /** @todo remove when http-client includes fix for accept-language header */
        'x-homeaway-displaylocale':
            window &&
            window.__INITIAL_STATE__ &&
            window.__INITIAL_STATE__.system &&
            window.__INITIAL_STATE__.system.locale
    }
});

// client-side apollo client
const client = new ApolloClient({
    cache,
    link,
    shouldBatch: true
});

// export as singleton
export default client;



// WEBPACK FOOTER //
// ./src/universal/client-side-apollo-client.js